var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DBox',{attrs:{"addButton":false,"addLink":false,"id":'cmp-booking-promoters-promoter-custom_fields',"topRightMenu":[
    {
      html: this.$t('promoter_custom_fields_hints'),
      icon: 'Help2.svg',
      value: 'question',
    } ]}},_vm._l(((_vm.customFields || [])),function(field,index){return _c('TextField2',{key:field.custom_field_id,attrs:{"id":"data","placeholder":field.field_label,"label":field.field_label,"value":field.data,"disabled":false},on:{"blur":function (e) { return _vm.onTextFieldValueChange(e, field); }}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }